import { render, staticRenderFns } from "./Priority.vue?vue&type=template&id=eefca4e2&scoped=true"
import script from "./Priority.vue?vue&type=script&lang=js"
export * from "./Priority.vue?vue&type=script&lang=js"
import style0 from "./Priority.vue?vue&type=style&index=0&id=eefca4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefca4e2",
  null
  
)

export default component.exports